exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".info-position{position:fixed;right:20px;bottom:20px;width:50px;height:50px;color:#fff;font-size:12px;line-height:50px;border-radius:25px;background-color:rgba(0,0,0,.4);text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-5d83d7d8","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./demo/components/SmoothingScroll.vue
// module id = 32
// module chunks = 0